import styled from 'styled-components'
import { Spacing } from 'cio-design-library/design-tokens'
import { foldableSectionMixin } from 'builder/components/Section'

export const SectionContainer = styled.div`
  position: relative;
  ${foldableSectionMixin};
`

export const SectionContent = styled.div``

export const BannerContainer = styled.div`
  margin-top: ${Spacing.S};
`
